export default {
  HOME: '/inicio',
  DOCUMENT_VERIFICATION: '/verificacion-documento',
  BENEFICIARIES_REGISTER: '/registro-beneficiarios',
  MINIMUM_PENSION_ESTIMATE: '/estimacion-pension-minima',
  ERROR: '/error',
}